import cloneDeep from 'lodash/cloneDeep'

export default (state = [], action) => {
  let { type, payload } = action
  let newState = cloneDeep(state)
  switch (type) {
    case 'LINES_SET':
      return payload
    case 'LINE_CREATE':
      newState.push(payload)
      return newState
    //return [payload, ...state]
    case 'LINE_UPDATE':
      return newState.map(item => {
        return item.id == payload.id ? Object.assign(item, payload) : item
      })
    case 'LINE_DELETE':
      return newState.filter(item => item.id != payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
